// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__21mTr","checkboxCol":"Table_checkboxCol__2mYbW","emailCol":"Table_emailCol__2Hw1G","actionCol":"Table_actionCol__eMpou"};